import axios from "./Axios";

// axios.defaults.baseURL = "http://localhost:9091/api/v1";
// axios.defaults.headers.common['Authorization'] = AUTH_TOKEN;
// axios.defaults.headers.post["Content-Type"] = "application/json";
export const registerNewUserAPI = async ({ username, email, password }) => {
  return new Promise((resolve, reject) => {
    axios
      .post("/api/v1/register", { username, email, password })
      .then((data) => {
        if (data) {
          resolve(data);
        }
      })
      .catch((error) => {
        reject(error);
      });
  });
};
export const createNewAppAPI = async ({
  appId,
  appName,
  bundleId,
  iconUrl,
  os,
  appUrl,
}) => {
  return new Promise((resolve, reject) => {
    axios
      .post("/api/v1/create-app", {
        appId,
        appName,
        bundleId,
        iconUrl,
        os,
        appUrl,
      })
      .then((data) => {
        if (data) {
          resolve(data);
        }
      })
      .catch((error) => {
        reject(error);
      });
  });
};
export const editAppAPI = async ({
  appId,
  appName,
  bundleId,
  iconUrl,
  os,
  appUrl,
  isActive,
}) => {
  return new Promise((resolve, reject) => {
    axios
      .post("/api/v1/edit-app", {
        appId,
        appName,
        bundleId,
        iconUrl,
        os,
        appUrl,
        isActive,
      })
      .then((data) => {
        if (data) {
          resolve(data);
        }
      })
      .catch((error) => {
        reject(error);
      });
  });
};
export const activeAppAPI = async ({ appId, isActive }) => {
  return new Promise((resolve, reject) => {
    axios
      .post("/api/v1/active-app", {
        appId,
        isActive,
      })
      .then((data) => {
        if (data) {
          resolve(data);
        }
      })
      .catch((error) => {
        reject(error);
      });
  });
};
export const userLoginAPI = async ({ email, password }) => {
  return new Promise((resolve, reject) => {
    try {
      axios
        .post("/api/v1/login", { email, password })
        .then((data) => {
          if (data) {
            resolve(data);
          }
        })
        .catch((error) => {
          reject(error);
        });
    } catch {
      reject("Request fail");
    }
  });
};
export const getAllAppAPI = async () => {
  return new Promise((resolve, reject) => {
    try {
      axios
        .get("/api/v1/list-app")
        .then((data) => {
          if (data) {
            resolve(data);
          }
        })
        .catch((error) => {
          reject(error);
        });
    } catch {
      reject("Request fail");
    }
  });
};
export const getAllUserAPI = async ({ page, limit }) => {
  return new Promise((resolve, reject) => {
    try {
      axios
        .get("/api/v1/all-users", { params: { page, limit } })
        .then((data) => {
          if (data) {
            resolve(data);
          }
        })
        .catch((error) => {
          reject(error);
        });
    } catch {
      reject("Request fail");
    }
  });
};
export const sendRequestApi = async ({ method, url, header, body, params }) => {
  console.log("URL:", url);
  console.log("method:", method);
  console.log("header:", header);
  console.log("body:", body);
  console.log("params:", params);
  const newHeader = {
    // "Content-Type": "application/json; charset=utf-8",
    // Accept: "application/json",
    // "User-Agent": "IeltsApp/148 CFNetwork/1335.0.3.4 Darwin/21.6.0",
    // "x-authorization": "X-AuthorizationEnglish",
    // "Accept-Language": "vi-VN,vi;q=0.9",
    // "Accept-Encoding": "gzip, deflate, br",
    // Authorization:
    //   "Bearer eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc0dvZE1vZGUiOmZhbHNlLCJ1c2VySWQiOiI2NGVlZjIyODhmNmM3OTM0MzVkMjA0OTMiLCJ1c2VyTmFtZSI6Ijg0ODI0NTgwNjkwLUlFTFRTIiwiaXNWZXJpZmllZCI6dHJ1ZSwiRGlzcGxheU5hbWUiOiI4NDgyNDU4MDY5MCIsIlByb3ZpbmNlSWQiOi0xLCJEaXN0cmljdElkIjotMSwiUGhvbmVOdW1iZXIiOiI4NDgyNDU4MDY5MCIsIlNjaG9vbFllYXIiOjIwMjMsImNvZGVBcHAiOiJBUFBFTkdMSVNISUVMVFMiLCJSb2xlIjoiU1RVREVOVCIsIkdlbmRlciI6Ik5BTSIsIkNyZWF0ZUJ5U2Nob29sIjotMSwicHJlbWl1bSI6ZmFsc2UsImNhbkNoYW5nZVBhc3N3b3JkIjp0cnVlLCJzdHVkZW50SWQiOiJPTkxVWUVOIElFTFRTIiwicGFja2FnZXMiOlsiSUVMQjJDMTIzNE41IiwiSUVMSlVOMTIiLCJJRUxPVkVSVklFVyJdLCJqdGkiOiI4MjM4MDQ5Zi04Yzc3LTQ1ZTMtOWJhZi1kZDg1ZWVjMDBmNmIiLCJpYXQiOjE3MTQwMTE0MDEsIm5iZiI6MTcxNDAxMTQwMSwiZXhwIjoxNzE2NjAzNDAxLCJpc3MiOiJFRE1JQ1JPIiwiYXVkIjoiT05MVVlFTi5WTiJ9.1lSr-cMUzsDKxca7T5sLg-UOlRoVh9DHfDjE_yU1xcA",
    // Referer: "ielts://vn.onluyen.ielts",
  };
  return new Promise((resolve, reject) => {
    try {
      if (url.length === 0) {
        reject("URL is Empty");
        return;
      }
      axios
        .get(url, {
          body: body.length > 0 ? JSON.parse(body) : {},
          params: params.length > 0 ? JSON.parse(params) : {},
          // headers: newHeader,
        })
        .then((data) => {
          if (data) {
            resolve(data);
          }
        })
        .catch((error) => {
          reject(error);
        });
    } catch (error) {
      reject(error);
    }
  });
};
